import { Component } from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { ChartFragment, MultiSectionsFragment } from 'models/api-response';
import { FragmentStatus } from 'models/enum';
import { RouteParams, RoutePath, SectionNavIdPatterns } from 'constants/app.constant';
import { chartHelper, dateTimeHelper } from 'helpers';
import { chartService } from 'services';
import { SavedPatientWrapper } from 'components/common';
import { TableItem } from 'components/common/saved-patient-charting/SavedPatientCharting';
import { FormField, SectionTitle } from '../constants';
import './saved-discharge-planning.scss';

interface MatchParams {
  assessmentId: string;
}

interface SavedDischargePlanningProps {
  enableMultiStepsAuthoring: Function;
}

class SavedDischargePlanning extends Component<SavedDischargePlanningProps & RouteComponentProps<MatchParams>> {
  static displayName = 'SavedDischargePlanning';

  componentDidMount() {
    this.props.enableMultiStepsAuthoring(true);
  }

  toTableData = (fragments: ChartFragment[]): TableItem[] => {
    return fragments.map((fragment) => ({
      active: fragment.active,
      enteredBy: `${fragment.creator?.firstName ?? ''} ${fragment.creator?.lastName ?? ''}`.trim() || chartService.formatName(fragment.creator),
      entryTime: dateTimeHelper.toDateTime(fragment.chartingAt),
      fragmentCreatorId: fragment.creator?.id,
      fragmentType: fragment.fragmentType,
      id: fragment.fragmentId,
      linkedFragmentId: fragment.linkedFragmentId,
      groupFragmentRef: fragment.groupFragmentRef,
      location: chartHelper.getFragmentRecords(fragment, SectionTitle.DISCHARGE_PLANNING, FormField.PROVIDER_NURSE)[0]?.content || '',
      providerNurse: chartHelper.getFragmentRecords(fragment, SectionTitle.DISCHARGE_PLANNING, FormField.PROVIDER_NURSE)[0]?.content || '',
      navElementId: fragment.navElementId,
      status: FragmentStatus.ACTIVE
    }));
  };

  handleUpdate = (row) => {
    const { assessmentId } = this.props.match.params;
    this.props.history.push({
      pathname: RoutePath.student.dischargePlanning.dischargePlanning.replace(RouteParams.ASSESSMENT_ID, assessmentId),
      search: `?id=${encodeURIComponent(row.id)}`
    });
  };

  buildStatusBadge = (fragment: MultiSectionsFragment) => {
    return { status: FragmentStatus.ACTIVE, isStatusBadgeActive: true };
  };

  render() {
    const columns = {
      location: {
        field: 'location',
        header: 'Charting Date'
      },
      type: {
        field: 'providerNurse',
        header: 'Provider / Nurse'
      },
      status: {
        field: 'status',
        header: 'Status',
        active: FragmentStatus.ACTIVE
      }
    };
    const deleteMessage = 'Are you sure you want to delete this entry?';

    const viewProps = {
      buildStatusBadge: this.buildStatusBadge,
      columns,
      chartTitle: 'Saved Discharge Planning',
      deleteMessage,
      hideDelete: true,
      navIds: [SectionNavIdPatterns.DISCHARGE_PLANNING],
      onRecordUpdate: this.handleUpdate,
      toTableData: this.toTableData,
      ...this.props
    };
    return (
      <div className="saved-discharge-planning">
        <SavedPatientWrapper {...viewProps} />
      </div>
    );
  }
}

export { SavedDischargePlanning as BaseSavedDischargePlanning };
export default withRouter(SavedDischargePlanning);
